













































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SearchCondition, Reservation, ReportCreateArgs } from '@/modules/reservation';
import { GradeYears, getGradeYearName } from '@/enums/gradeYears';
import { FunctionTypes } from '@/enums/functionTypes';
import { Tutor } from '@/modules/tutor';
import { Subject } from '@/models/subject';
import { Person } from '@/models/person';
import { School } from '@/modules/school';
import AvaivaledVue from '@/components/avaivaled.vue';

@Component
export default class extends AvaivaledVue {
  private getGradeYearName = getGradeYearName;

  private get pageTitle() { return '予約一覧'; }
  private get headerIcon() { return 'fa fa-clipboard-list fa-2x'; }
  private get isLoading() {
    return(
    this.$store.state.reservation.isLoading ||
      this.$store.state.tutor.loading ||
      this.$store.state.adminSchool.loading);
  }

  private get isReportCreate() {
    const reportCreateArgsList: ReportCreateArgs[] = this.$store.state.reservation.reportCreateArgsList;
    return reportCreateArgsList && reportCreateArgsList.length > 0;
  }

  private get countAll() { return this.$store.state.reservation.countAll; }
  private get condition(): SearchCondition { return this.$store.state.reservation.searchCondition; }
  private get isMini(): boolean { return (this as any).$mq === 'mini'; }
  private get tableDatas(): Reservation[] { return this.$store.state.reservation.list; }
  private get tutors(): Tutor[] { return this.$store.state.tutor.users; }
  private subjects: Subject[] = [];
  private schoolName: string = '';
  private showSearchCondition = true;
  private isResetReportCreateArgsList = true;
  private school?: School;
  private showedDifferentDateMessage = false;

  private async loadData() {
    this.$store.dispatch('reservation/getListRequest');

    // 全ての講師を取得
    this.$store.dispatch('tutor/searchTutors', {
      authoriry: 2,
      keyWord: '',
      perPage: 10000,
      page: 1,
      sort: '',
    });

    // スクール情報を取得
    const school = await this.$store.dispatch('adminSchool/getSchool', this.$store.getters['auth/schoolId']);
    this.subjects = JSON.parse(JSON.stringify(school.subjectList));
    this.schoolName = school.schoolName;
  }
  private mounted() {
    this.loadData();
  }

  private created() {
    this.pageBackCheck(FunctionTypes.Reserve);
  }

  private deactivated() {
    if (this.isResetReportCreateArgsList) {
      this.$store.commit('reservation/setReportCreateArgsList', []);
    }
    this.$destroy();
  }

  private onPageSizeChange(val: number) { this.condition.perPage = val; }
  private onChangePage() { this.loadData(); }
  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }
  private onChangeSort( {prop, order}: any ) {
    this.condition.sort = prop ? `${prop} ${order}` : '';
    this.loadData();
  }

  private onChangeSelection(checked: Reservation[]) {
    let hasDifferentDate = false;
    const argsList: ReportCreateArgs[] = [];
    checked.forEach((reserve) => {
      const startDate = new Date(reserve.unixtimeStartDate * 1000);
      const endDate = new Date(reserve.unixtimeEndDate * 1000);
      const subject = reserve.subject;

      const args = argsList.find((value) => value.studentId === reserve.student!.studentId);

      if (args) {
        const startDateCheck = args.startDate!;
        const endDateCheck = args.endDate!;

        if (startDate !== startDateCheck || endDate !== endDateCheck) {
          hasDifferentDate = true;
        }
        if (startDate < startDateCheck) {
          args.startDate = startDate;
        }
        if (endDate > endDateCheck) {
          args.endDate = endDate;
        }

        if (args.subjects.some((value) => value.id !== subject.id)) {
          hasDifferentDate = true;
          args.subjects.push(subject);
        }
      } else {
        argsList.push({
          studentId: reserve.student!.studentId,
          studentName: reserve.student!.lastName + ' ' + reserve.student!.firstName,
          startDate,
          endDate,
          subjects: [reserve.subject]
        });
      }
    });

    this.$store.commit('reservation/setReportCreateArgsList', argsList);

    if (hasDifferentDate) {
      if (!this.showedDifferentDateMessage) {
        this.showedDifferentDateMessage = true;
        this.$alert('同じ生徒で複数の開始/終了時刻、または教科の予約が選択されています。', '', {
          type: 'warning'
        });
      }
    } else {
        this.showedDifferentDateMessage = false;
    }
  }

  private unixtimeToDate(unixtime: number): Date {
    return new Date(unixtime * 1000);
  }

  private unixtimeToHoursString(unixtime: number): string {
    return ('0' + this.unixtimeToDate(unixtime).getHours().toString()).slice(-2);
  }

  private unixtimeToMinutesString(unixtime: number): string {
    return ('0' + this.unixtimeToDate(unixtime).getMinutes().toString()).slice(-2);
  }

  private output() {
    this.$store.dispatch('reservation/outputRequest', this.schoolName);
  }

  private gotoReportCreate() {

    if (this.isReportCreate) {
      this.isResetReportCreateArgsList = false;
      this.$router.push({ name: 'ReportCreate' });
      return;
    }

    this.$alert('指導報告書を作成する生徒が選択されていません。', '', {
      type: 'error',
      confirmButtonText: 'OK',
    });
  }
}
